export const formatDefaultValue = (defaultValue: string) => {
  try {
    return JSON.stringify(JSON.parse(defaultValue), null, 2);
  } catch {
    return defaultValue;
  }
};
